import React from 'react';

import { Heading as RadixHeading } from '@radix-ui/themes';
import cn from 'classnames';

import { getFlyToRadixColor } from '../utils';
import {
  HeadingProps,
  sizeToClassName,
  weightToClassName,
} from './Heading.types';

function Heading({
  color = 'neutral',
  weight = 'bold',
  size,
  ref,
  ...props
}: HeadingProps & { ref?: React.Ref<HTMLHeadingElement> }) {
  return (
    <RadixHeading
      {...props}
      color={getFlyToRadixColor(color)}
      size={size}
      ref={ref}
      className={cn(
        props.className,
        size ? sizeToClassName[size] : '',
        weight ? weightToClassName[weight] : ''
      )}
    />
  );
}

export { Heading };
